import { render } from "./ProductCharacteristics.vue?vue&type=template&id=53d26687&scoped=true"
import script from "./ProductCharacteristics.vue?vue&type=script&lang=js"
export * from "./ProductCharacteristics.vue?vue&type=script&lang=js"

import "./ProductCharacteristics.vue?vue&type=style&index=0&id=53d26687&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d26687"]])

export default __exports__